export enum PatientMedicalHistoryLayoutOptionsConstants {
  BASIC = 0,
  ICD_10_NEMSIS_STANDARD = 1,
  ICD_10_NEMSIS_BASIC = 2,
}
